import React from 'react';
import { RadioGroup } from '@material-ui/core';

import useStyles from './MultiButton.style';

export interface MultiButtonProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: {
    label: string;
    value: string;
    disabled?: boolean;
  }[];
  getCheckedValue: (value: string) => boolean;
  radioGroupName: string;
  variant?: 'big' | 'small';
}
const MultiButton: React.FC<MultiButtonProps> = ({ options, onChange, getCheckedValue, radioGroupName, variant = 'small' }) => {
  const c = useStyles({ variant });

  const renderRadioItem = (option: { label: string; value: string; disabled?: boolean }) => (
    <MultiButtonItem
      key={option.value}
      label={option.label}
      value={option.value}
      radioGroupName={radioGroupName}
      checked={getCheckedValue(option.value)}
      onChange={onChange}
      variant={variant}
      disabled={option.disabled}
    />
  );

  return (
    <RadioGroup
      className={c.root}
      aria-labelledby={radioGroupName}
      defaultValue=""
      name={radioGroupName}
    >
      {options.map(renderRadioItem)}
    </RadioGroup>
  );
};

interface MultiButtonItemProps {
  label: string;
  value: string;
  radioGroupName: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: 'big' | 'small';
  disabled?: boolean;
}

const MultiButtonItem: React.FC<MultiButtonItemProps> = ({
  label,
  value,
  radioGroupName,
  checked,
  onChange,
  variant = 'small',
  disabled
}) => {
  const c = useStyles({ checked, variant });
  const itemId = `${radioGroupName}-${value}-${label}`;

  return (<div className={c.multiButtonItem} data-disabled={disabled || undefined}>
    <input
      type="radio"
      id={itemId}
      checked={checked}
      key={value}
      name={radioGroupName}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={c.radioInput}
    />
    <label className={c.radioLabel} htmlFor={itemId}>
      {label}
    </label>
  </div>
  );
};

export { MultiButton };
